import {
  Checkbox
} from "@fluentui/react-components";
import { useCallback, useContext, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import ArrowForward from "../../assets/svg/arrow_forward.svg";
import CustomButton from "../../components/controls/button/Button";
import CheckboxInputStateSave from "../../components/controls/checkboxStateSave/CheckboxStateSave";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import { default as CustomInput, default as Input } from "../../components/controls/input/customInput/CustomInput";
import InputUnderline from "../../components/controls/input/InputUnderline";
import Modal from "../../components/controls/modal/Modal";
import Search from "../../components/header/CustomSearch";
import CustomPopover from "../../components/popover/Popover";
import {
  getLabelByType,
  scopePriorityOptions,
  ScopeStatus
} from "../../helpers/utils";
import {
  AddIconSvg,
  ArrowDownMedium,
  BaselineIcon,
  CalendarIcon,
  Cross,
  DayIcon,
  FilterIconSvg,
  ModalCloseIcon,
  MonthIcon,
  PlusIconWhite,
  QuarterIcon,
  ScopeViewIcon,
  SelectArrowDownIcon,
  TaskViewIcon,
  WeekIcon
} from "../../modules/default-svg";
import scopeService from "../../store/services/scope.service";
import { isDateGreaterThan } from "../../utils/systemSettings";
import SearchedResource from "../resourcePlanner/resourceMonitoring/SearchedResource";
import styles from "./dashboard.module.scss";

// import CheckboxInput from "../../components/controls/checkbox/Checkbox";
import moment from "moment";
import EntityFileUpload from "../../components/controls/fileUpload/EntityFileUpload";
import ModalCheckbox from "../../components/controls/modalcheckbox/ModalCheckbox";
import DateRangeWithDuration from "../../components/dateRangeWithDuration/DateRangeWithDuration.jsx";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import { generalActions } from "../../store/actions";
import {
  createScopeRequest,
  createTask,
  resourcesShiftsRequest,
  updateTask
} from "../../store/actions/scope.actions";
import {
  resourceShifts,
  scopeStatusLoading,
  taskLoading
} from "../../store/selectors/scope.selector";
import { ResourceMoniteringContext } from "../resourcePlanner/resourceMonitoring/ResourceContext";
import AssociatedRisks from "../risk/AssociatedRisks";
import CreateEditTask from "../scopeOverview/CreateEditTask.jsx";
import { GanttChart } from "./components/GanttChart";
import { NoProjects } from "./components/NoProjects";
import ConflictsToast from "../ResourcesPlanner/components/ConflictsToast.jsx";
import ReportButton from "../../components/Export/ReportButton.jsx";
import ExportButton from "../../components/Export/ExportButton.jsx";

const App = ({
  resourcesShiftsRequest,
  scopeLoading,
  taskLoader,
  openPopover,
  setIsOpenPopover,
  overviewType,
  isHeaderCollapsed = false
}) => {
  const dispatch = useDispatch();
  const [searchedResources, setSearchedResources] = useState([]);
  const [selectedResources, setSelectedResources] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [isHideSideBar, setIsHideSideBar] = useState(false);
  const [isHideTask, setIsHideTask] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [baseLine, setBaseLine] = useState(false);
  const [critical, setCritical] = useState(false);
  const [popupTask, setPopupTask] = useState(false);
  const popupPosition = { top: 187, left: 125 };
  const [refId, setRefId] = useState("");
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const [selection, setSelection] = useState({
    icon: <MonthIcon />,
    name: "Month",
  });
  const [selectedStatus, setSelectedStatus] = useState([]);

  /////////////////////////////////// SCOPE ///////////////////////////////////////////
  const [scopeItem, setScopeItem] = useState(null);
  const [isScopeLoading, setScopeLoading] = useState(false);
  const [showScopeModal, setShowScopeModal] = useState(false);
  const [scopeName, setScopeName] = useState("");
  const [scopeStartDate, setScopeStartDate] = useState("");
  const [endScopeDate, setScopeEndDate] = useState("");
  const [revisedEndDate, setRevisedEndDate] = useState("");
  const [priority, setPriority] = useState("");
  const [budget, setBudget] = useState("");
  const [completion, setCompletion] = useState("");
  const [phase, setPhase] = useState("");
  const [status, setStatus] = useState(0);
  const [progress, setProgress] = useState(0);
  const [description, setDescription] = useState("");
  const [ProjectId, setProjectId] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [isMilestone, setIsMilestone] = useState(false);
  const [isScopeInWSR, setIsScopeInWSR] = useState(false);
  const [risks, setRisks] = useState([]);
  const [scopeLoader, setScopeLoader] = useState(false);
  const [formErrors, setFormErrors] = useState({
    scopeName: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
    completion: "",
    projectId: "",
  });

  /////////////////////////////////// TASK ///////////////////////////////////////////
  const [taskModal, setTaskModal] = useState({
    isOpen: false,
    isEdit: false,
    taskId: null,
    project: null,
    scope: null,
  });

  const [count, setCount] = useState(0);

  const {
    setFilterStartDate,
    setFilterEndDate,
    filterCount,
    setFilterUsers,
    setFilterStatus,
    checkBaselineability,
    isBaselineable,
    baselinez,
    setFilterBaseLine,
    createBaseline,
    project,
    projects,
    taskDetails,
    isTimelineLoading,
    isCalendarLoading,
    setTodayTrigger,
    displayYearRange,
    tabView,
    setTabView,
    handleCreateScope,
    fetchAndSetTimelineData,
    conflictsToasts,
    removeConflictsToast
  } = useContext(ResourceMoniteringContext);

  const [selectedBaseline, setSelectedBaseline] = useState(null);

  useEffect(() => {
    setScopeItem(null);
  }, []);
  /////////////////////////////////// TASK ///////////////////////////////////////////

  const closeTaskModal = useCallback(() => {
    setTaskModal({
      isOpen: false,
      isEdit: false,
      taskId: null,
      project: null,
      scope: null
    });
  }, []);

  useEffect(() => {
    if (tabView) {
      switch (tabView) {
        case "week":
          setSelection({ icon: <WeekIcon />, name: "Week" });
          break;

        case "day":
          setSelection({ icon: <DayIcon />, name: "Day" });
          break;

        case "quarter":
          setSelection({ icon: <QuarterIcon />, name: "Quarter" });
          break;

        default:
          setSelection({ icon: <MonthIcon />, name: "Month" });
          break;
      }
    }
  }, [tabView]);

  useEffect(() => {
    if (baselinez.length > 0 && !selectedBaseline) {
      setSelectedBaseline(baselinez[0].id);
    } else if (baselinez.length === 0) {
      setSelectedBaseline(null);
    }
  }, [baselinez]);

  const baselineSelectHandler = (id) => {
    setSelectedBaseline(id);
  };

  const handleSelectStatus = (id) => {
    if (!selectedStatus.includes(id)) {
      setSelectedStatus(() => [...selectedStatus, id]);
    } else {
      let tempShift = [...selectedStatus];
      let shiftIndexDelete = tempShift.indexOf(id);
      tempShift.splice(shiftIndexDelete, 1);
      setSelectedStatus(() => tempShift);
    }
  };

  const handleBaseline = async () => {
    await checkBaselineability();
    setBaseLine(!baseLine);
    setCritical(false);
  };

  const TaskPopup = ({ task, position, onClose }) => {
    return (
      <div
        className={styles.createTaskPopover}
        style={{
          position: "absolute",
          top: 36,
          left: 37,
          width: "110px",
        }}
      >
        <div>
          <div
            className={styles.createTaskContent}
            onClick={() => {
              onClose();
              setTaskModal({
                isOpen: true,
                isEdit: false,
                taskId: null,
                project: project,
                scope: null,
              });
            }}
          >
            <span>Create Task</span>
          </div>
          <div
            className={styles.createTaskContent}
            onClick={() => {
              onClose();
              handleScopeReset();
              setScopeItem(null);
              setShowScopeModal(true);
            }}
          >
            <span>Create Scope</span>
          </div>
        </div>
      </div>
    );
  };

  const closePopup = () => setPopupTask(null);

  const handleSearchResult = (res) => {
    setSearchedResources(res);
  };

  const handleSelectResource = (resource) => {
    setSelectedResources((prevSelected) => {
      if (prevSelected.includes(resource)) {
        return prevSelected.filter((res) => res !== resource);
      } else {
        return [...prevSelected, resource];
      }
    });
  };

  const handleInputChange = (value, name) => {
    if (name === "startDate") setScopeStartDate(value);
    if (name === "endDate") setScopeEndDate(value);
    if (name === "revisedEndDate") setRevisedEndDate(value);
    if (name === "completion") setCompletion(value);
    if (name === "isScopeInWSR") setIsScopeInWSR(value);
    if (name === "scopeName") {
      setScopeName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const handleScopeCancel = () => {
    setScopeItem(null);
    handleScopeReset();
    setShowScopeModal(false);
    setScopeLoader(false);
  };

  const setRequestPriority = (type) => {
    switch (type) {
      case "Low":
        return 0;
      case "Moderate":
        return 1;
      case "High":
        return 2;
      default:
        return 0;
    }
  };

  const handleScopeSave = async () => {
    if (!budget) setBudget(null);
    if (!completion) setCompletion(null);
    const errors = {};
    if (
      scopeStartDate &&
      endScopeDate &&
      isDateGreaterThan(scopeStartDate, endScopeDate)
    ) {
      errors["endDate"] = `End date must be greater than start date.`;
    }
    if (
      endScopeDate &&
      revisedEndDate &&
      isDateGreaterThan(endScopeDate, revisedEndDate)
    ) {
      errors[
        "revisedEndDate"
      ] = `Revised end date must be equal to or greater than end date.`;
    }
    if (completion && isNaN(completion)) {
      errors["completion"] = `Completion must be a number.`;
    } else if (completion && (completion < 0 || completion > 100)) {
      errors["completion"] = `Completion must be between 0 and 100.`;
    }
    if (!scopeName) errors["scopeName"] = `The Name field is required.`;

    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }
    const payload = {
      Name: scopeName,
      ProjectId: project.id,
      StartDate: scopeStartDate ? scopeStartDate : null,
      EndDate: endScopeDate ? endScopeDate : null,
      RevisedEndDate: revisedEndDate ? revisedEndDate : null,
      Priority: setRequestPriority(priority.value),
      Budget: budget ? budget : 0,
      Phase: phase,
      Status: status,
      RefId: refId,
      Description: description,
      IsInWsr: isScopeInWSR
    };
    setScopeLoader(true);
    handleCreateScope(payload);
    setTimeout(() => handleScopeCancel(), 300);
  };

  const handleScopeReset = () => {
    setShowScopeModal(false);
    setScopeName("");
    setScopeStartDate("");
    setScopeEndDate("");
    setRevisedEndDate("");
    setPriority("");
    setBudget("");
    setCompletion("");
    setPhase("");
    setStatus(0);
    setDescription("");
    setProjectId("");
    setIsScopeInWSR(false);
    setScopeLoader(false);
  };


  const scopeForm = () => {
    return (
      <div>
        <div className="d-flex align-items-end justify-content-between">
          <div className={scopeItem ? "col-10" : "col-12"}>
            <InputUnderline
              placeholder="Add scope name"
              value={scopeName}
              error={formErrors.scopeName}
              handleChange={(value) => handleInputChange(value, "scopeName")}
              isRequired
              loading={isScopeLoading}
            />
          </div>
          {scopeItem && (
            <div className="col-1 ml-2">
              <label class="Input_label">Progress</label>
              <p
                style={{ border: "1px solid #342C82" }}
                className="text-xs text-[#1F1F1F] font-semibold bg-[#EDECF8] text-center py-[4px] rounded-md"
              >
                {`${progress} %`}
              </p>
            </div>
          )}
        </div>
        <div className="mt-3 mb-2 flex col-10 gap-3">
          <ModalCheckbox
            label={isMilestone ? "Milestone" : "Mark as Milestone"}
            checked={isMilestone}
            setChecked={setIsMilestone}
          />
          <ModalCheckbox
            label={isScopeInWSR ? "In WSR" : "Include in WSR"}
            checked={isScopeInWSR}
            setChecked={setIsScopeInWSR}
            loading={isScopeLoading}
          />
        </div>
        {scopeItem && (
          <AssociatedRisks isLoading={isScopeLoading} risks={risks} />
        )}
        <div className="row align-items-center gx-3 mb-3">
          <DateRangeWithDuration
            isLoading={isScopeLoading}
            startDate={scopeStartDate}
            endDate={endScopeDate}
            revisedEndDate={revisedEndDate}
            onStartDateChange={(value) => handleInputChange(value, "startDate")}
            onEndDateChange={(value) => handleInputChange(value, "endDate")}
            onRevisedEndDateChange={(value) => handleInputChange(value, "revisedEndDate")}
            showRevisedEndDate={true}
            icon={<CalendarIcon />}
          />
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <DropDown
              label="Priority"
              options={scopePriorityOptions}
              defaultVal={getLabelByType("scopePriority", priority)}
              onChange={setPriority}
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              value={budget}
              placeholder="0"
              type="number"
              currency={true}
              handleChange={setBudget}
              label="Budget"
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="0 %"
              value={completion}
              type="number"
              handleChange={(value) => handleInputChange(value, "completion")}
              label="Completion"
              errorMessage={formErrors.completion}
              loading={isScopeLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter phase"
              value={phase}
              type="text"
              handleChange={setPhase}
              label="Phase"
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Status"
              options={ScopeStatus}
              defaultVal={getLabelByType("scope", status)}
              onChange={setStatus}
              loading={isScopeLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter Reference ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Reference ID"
              loading={isScopeLoading}
            />
          </div>
        </div>
        <div className="mb-3">
          <RichTextEditor
            label="Description"
            content={description}
            onChange={setDescription}
            loading={isScopeLoading}
          />
        </div>
        <EntityFileUpload
          entityId={scopeItem?.id}
          entityType="Scope"
          attachments={attachments}
          onAttachmentsChange={() => {
            if (scopeItem?.id) {
              scopeService
                .getScopeDetailsRequest({ id: scopeItem.id })
                .then((scopeData) => {
                  setAttachments(scopeData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching scope data:", error);
                });
            }
          }}
          disabled={isScopeLoading || !scopeItem?.id}
        />
      </div>
    );
  };

  useEffect(() => {
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId]);

  useEffect(() => {
    setScopeLoader(scopeLoading);
    setShowScopeModal(false);
    setScopeName("");
    setProjectId("");
    setStartDate("");
    setEndDate("");
    setRevisedEndDate("");
    setPriority("");
    setBudget("");
    setCompletion("");
    setPhase("");
    setStatus(0);
    setRefId("");
    setDescription("");
    setPopupTask(false);
  }, [scopeLoading]);

  useEffect(() => {
    if (scopeItem) {
      setShowScopeModal(true);
      setScopeLoading(true);
      scopeService
        .getScopeDetailsRequest({ id: scopeItem.id })
        .then((scopeData) => {
          setScopeName(scopeData.name);
          setScopeStartDate(scopeData.startDate);
          setScopeEndDate(scopeData.endDate);
          setRevisedEndDate(scopeData.revisedEndDate);
          setPriority(scopeData.priority);
          setBudget(scopeData.budget);
          setPhase(scopeData.phase);
          setStatus(scopeData.status);
          setRefId(scopeData.refId);
          setDescription(scopeData.description);
          setProgress(scopeData.progress);
          setIsMilestone(scopeData.isMilestone);
          setProjectId(scopeData.project.id ?? "");
          setRisks(scopeData.risks);
          setAttachments(scopeData.attachments || []);
          setIsScopeInWSR(scopeData.isInWsr);
        })
        .catch((error) => {
          dispatch(
            generalActions.showToast({
              title: `Error fetching scope data ${error}`,
              type: "error",
            })
          );
        })
        .finally(() => {
          setScopeLoading(false);
        });
    }
  }, [scopeItem]);


  const handleEditTaskModal = async (task) => {
    setTaskModal({
      isOpen: true,
      isEdit: true,
      taskId: task.id,
      project: project,
      scope: null,
    });
  };


  if (
    !isTimelineLoading &&
    !isCalendarLoading &&
    (!projects || projects.length === 0)
  )
    return <NoProjects />;
  return (
    <>
      <div className="d-flex flex-column gap-2 h-full">
        <div
          className={styles.container}
          style={{
            height: overviewType === "Project" && `calc(100vh - ${isHeaderCollapsed ? '120px' : '420px'})`,
          }}
        >
          <div className={styles.secondHeader}>
            <div className={styles.content}>
              <CustomButton
                icon={<ScopeViewIcon isHide={isHideSideBar} />}
                clickHandler={() => { setIsHideSideBar(!isHideSideBar); }}
              />
              <div className="d-flex" onClick={() => setPopupTask(!popupTask)}>
                <CustomButton
                  icon={<PlusIconWhite />}
                  btnClass="btn_combo btn_combo_primary"
                  label="Create"
                />
                <CustomButton
                  btnClass="btn_combo btn_combo_secondary"
                  icon={<SelectArrowDownIcon color="white" />}
                />
              </div>
              {popupTask && (
                <TaskPopup
                  task={popupTask}
                  position={popupPosition}
                  onClose={closePopup}
                />
              )}
              <CustomPopover
                icon={
                  <div className={styles.filter}>
                    <CustomButton
                      btnClass="btn_combo btn_combo_white"
                      icon={<FilterIconSvg />}
                      label="Filter"
                      clickHandler={() => {
                        setIsOpenPopover("filters");
                      }}
                    />

                    {filterCount > 0 && (
                      <div className={styles.filterCounterContainer}>
                        <span className={styles.filterCounter}>
                          {filterCount}
                        </span>
                      </div>
                    )}
                  </div>
                }
                PopSurfaceClass="FilterPopoverSurface"
                width={"456px"}
                status={openPopover === "filters"}
              >
                <div
                  style={{
                    zIndex: 50,
                  }}
                  className="d-flex flex-column"
                >
                  <div className="d-flex justify-content-between align-items-center FilterPopoverHeader">
                    <h4 className=" ">Filter</h4>
                    <div onClick={() => setIsOpenPopover(null)}>
                      <Cross />
                    </div>
                  </div>
                  <div className="FilterPopoverBody">
                    <div className="FilterPopoverBodyScroll">
                      <div className="assignAvatarBody d-flex flex-column mb-32">
                        <div>
                          <Search
                            parentType="Shift"
                            type="Resource"
                            searchResult={handleSearchResult}
                          />
                          <div className="mt-2 userChipWrapper">
                            {searchedResources.map((res) => (
                              <SearchedResource
                                key={res.id}
                                item={res}
                                isActive={selectedResources.includes(res)}
                                onSelect={() => handleSelectResource(res)}
                              />
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 mb-32">
                        <h6>Status</h6>
                        <div className="d-flex gap-5">
                          <div className="d-flex flex-column gap-2">
                            <CheckboxInputStateSave
                              label="Inprogress"
                              checked={selectedStatus.includes("0")}
                              onChange={() => handleSelectStatus("0")}
                            />
                            <CheckboxInputStateSave
                              label="Monitoring"
                              checked={selectedStatus.includes("1")}
                              onChange={() => handleSelectStatus("1")}
                            />
                          </div>
                          <div className="d-flex flex-column gap-2">
                            <CheckboxInputStateSave
                              label="Completed"
                              checked={selectedStatus.includes("3")}
                              onChange={() => handleSelectStatus("3")}
                            />
                            <CheckboxInputStateSave
                              label="Slipping"
                              checked={selectedStatus.includes("2")}
                              onChange={() => handleSelectStatus("2")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column gap-2">
                        <h6>Resource working on dates</h6>
                        <div className="d-flex align-items-center justify-content-between">
                          <CustomInput
                            type="date"
                            icon={<CalendarIcon />}
                            label="Start date"
                            width={"182px"}
                            handleChange={setStartDate}
                            value={startDate}
                          />

                          <img
                            src={ArrowForward}
                            alt="Next Arrow"
                            className="mt-4"
                          />

                          <CustomInput
                            type="date"
                            icon={<CalendarIcon />}
                            label="End date"
                            width={"182px"}
                            handleChange={setEndDate}
                            value={endDate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-end gap-2 justify-content-end FilterPopoverFooter">
                    <CustomButton
                      btnClass="d_btn d_btn_white d_btn_whiteMd"
                      label="Clear All"
                      clickHandler={() => {
                        setFilterStartDate(null);
                        setFilterEndDate(null);
                        setStartDate(null);
                        setEndDate(null);
                        setIsOpenPopover(null);
                        setSearchedResources([]);
                        setFilterUsers([]);
                        setFilterStatus([]);
                        setSelectedStatus([]);
                        setSelectedResources([]);
                      }}
                    />
                    <CustomButton
                      btnClass="d_btn d_btn_primary d_btn_primaryMd"
                      label="Apply"
                      clickHandler={() => {
                        setFilterStartDate(() => startDate);
                        setFilterEndDate(() => endDate);
                        setFilterUsers(() => selectedResources);
                        setIsOpenPopover(() => null);
                        setFilterStatus(() => selectedStatus);
                        // setFilterShifts(selectedShift);
                        // setFilterCapacity(selectedCapacity);
                      }}
                    />
                  </div>
                </div>
              </CustomPopover>
              <CustomButton
                btnClass="btn_combo btn_combo_white"
                icon={<TaskViewIcon />}
                label={isHideTask ? "Unhide Tasks" : "Hide Tasks"}
                clickHandler={() => { setIsHideTask(!isHideTask); }}
              />
            </div>
            <div className={styles.secondaryContent}>
              <div className={styles.featuresContainer}>
                <ReportButton
                  parentType="Project"
                  parentId={project.id}
                />
                <ExportButton config={{ parent: 3, parentId: project.id, category: 5 }} />
              </div>
              {overviewType === "Project" && (
                <CustomButton
                  btnClass="todayBtn"
                  label="Today"
                  name="today"
                  id="cars"
                  clickHandler={() => {
                    setTodayTrigger(false);
                    setTimeout(() => {
                      setTodayTrigger(true);
                    }, 0);
                  }}
                />
              )}
              <CustomButton
                icon={
                  <img
                    src={`${process.env.PUBLIC_URL}/Critical.svg`}
                    alt="critical-path"
                  />
                }
                label="Critical Pathss"
                btnClass={`btn_combo btn_combo_whiteSm btn_combo_white_borderless ${!critical && "btn_combo_unSelected"
                  }`}
                clickHandler={() => {
                  // setSelectedBaseline(null);
                  // setBaseLine(false);
                  // setFilterBaseLine(null);
                  setCritical((prev) => !prev);
                }}
              />
              <CustomPopover
                status={baseLine}
                icon={
                  <CustomButton
                    icon={
                      <img
                        src={`${process.env.PUBLIC_URL}/baseline.svg`}
                        alt="baseline"
                      />
                    }
                    label="Baseline"
                    btnClass={`btn_combo btn_combo_whiteSm btn_combo_white_borderless ${!selectedBaseline && "btn_combo_unSelected"
                      }`}
                    clickHandler={handleBaseline}
                  />
                }
                width="456px"
                PopSurfaceClass={`${styles.AddBaselineWrap} ${styles.MiniModalsWrap}`}
              >
                <div className={styles.modalHeader}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h5>Baseline</h5>
                    <span
                      className="d-inline-flex"
                      onClick={() => setBaseLine(false)}
                    >
                      <ModalCloseIcon />
                    </span>
                  </div>
                </div>
                <div className={styles.modalBody}>
                  {isBaselineable ? (
                    <>
                      <p className="mb-12">
                        Baseline bars on the Gantt chart show the original
                        schedule and budget, highlighting variances from change
                        requests and delays.
                      </p>
                      <CustomButton
                        label="Add baseline"
                        icon={<AddIconSvg />}
                        btnClass="d_btn d_btn_primary"
                        clickHandler={createBaseline}
                      />
                      {baselinez.map((item) => (
                        <div className="d-flex align-items-center justify-content-between gap-3 mt-2">
                          <div className="d-flex align-items-center gap-2">
                            <BaselineIcon />
                            <p className="textsetFilterBaseLine-sm-400 greyStrokeColor">
                              Baseline_{moment(item?.dateCreated).format("YYMMDD")} ({moment(item?.dateCreated).format("DD MMM YYYY")})
                            </p>
                          </div>
                          <Checkbox
                            checked={selectedBaseline === item.id}
                            onChange={() => baselineSelectHandler(item.id)}
                          />
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      <p
                        className="text-sm-400 mb-3"
                        style={{ color: "#c50f1f" }}
                      >
                        There have been no approved change requests to date, and
                        the project estimation remains unchanged. The current
                        view reflects the previously recorded baseline.
                      </p>
                      <div className="">
                        <span className="text-sm-500">Baselines history</span>
                        {baselinez.map((item) => (
                          <div className="d-flex align-items-center justify-content-between gap-3 mt-2">
                            <div className="d-flex align-items-center gap-2">
                              <BaselineIcon />
                              <p className="textsetFilterBaseLine-sm-400 greyStrokeColor">
                                Baseline_{moment(item?.dateCreated).format("YYMMDD")} ({moment(item?.dateCreated).format("DD MMM YYYY")})
                              </p>
                            </div>
                            <Checkbox
                              checked={selectedBaseline === item.id}
                              onChange={() => baselineSelectHandler(item.id)}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                <div className={styles.modalFooter}>
                  <div className={styles.btnContainer}>
                    <CustomButton
                      label="Cancel"
                      btnClass="d_btn d_btn_smallWhite me-10"
                      btnType="secondary"
                      clickHandler={() => {
                        setSelectedBaseline(null);
                        setBaseLine(false);
                        setFilterBaseLine(null);
                      }}
                    />
                    <CustomButton
                      label="View"
                      btnClass="d_btn d_btn_primary"
                      clickHandler={() => {
                        setFilterBaseLine(selectedBaseline);
                        setBaseLine(false);
                      }}
                    />
                  </div>
                </div>
              </CustomPopover>
              <CustomPopover
                icon={
                  <CustomButton
                    icon={selection.icon}
                    label={selection.name}
                    btnClass={`${styles.calendarBtn} d_btn`}
                    rightIcon={
                      <span className="ms-6 d-inline-flex">
                        <ArrowDownMedium />
                      </span>
                    }
                    clickHandler={() =>
                      setIsOpenPopover(openPopover === "range" ? null : "range")
                    }
                  />
                }
                width="96px"
                PopSurfaceClass={styles.calendarPopover}
                status={openPopover === "range"}
              >
                <div
                  className={styles.calendarPopoverItem}
                  onClick={() => {
                    setTabView("quarter");
                    setSelection({ icon: <QuarterIcon />, name: "Quarter" });
                    setCount((prev) => prev + 1);
                    setIsOpenPopover(null);
                  }}
                >
                  <QuarterIcon />
                  Quarter
                </div>
                <div
                  className={styles.calendarPopoverItem}
                  onClick={() => {
                    setTabView("month");
                    setSelection({ icon: <MonthIcon />, name: "Month" });
                    setCount((prev) => prev + 1);
                    setIsOpenPopover(null);
                  }}
                >
                  <MonthIcon />
                  Month
                </div>
                <div
                  className={styles.calendarPopoverItem}
                  onClick={() => {
                    setTabView("week");
                    setSelection({ icon: <WeekIcon />, name: "Week" });
                    setCount((prev) => prev + 1);
                    setIsOpenPopover(null);
                  }}
                >
                  <WeekIcon />
                  Week
                </div>
                <div
                  className={styles.calendarPopoverItem}
                  onClick={() => {
                    setTabView("day");
                    setSelection({ icon: <DayIcon />, name: "Day" });
                    setCount((prev) => prev + 1);
                    setIsOpenPopover(null);
                  }}
                >
                  <DayIcon />
                  Day
                </div>
              </CustomPopover>
              {/* <CustomButton
                clickHandler={() =>
                  !displayType ? setDisplayType("gantt") : setDisplayType(null)
                }
                icon={
                  <img
                    src={
                      !displayType
                        ? `${process.env.PUBLIC_URL}/ArrowExpand.svg`
                        : `${process.env.PUBLIC_URL}/ArrowContract.svg`
                    }
                    alt="arrow"
                  />
                }
                btnClass={styles.ArrowExpandStyles}
              /> */}
              {/* <MeatBallsMenuIcon /> */}
            </div>
          </div>
          <GanttChart
            viewType={selection.name}
            showTaskModal={(scope, status) => {
              setTaskModal({
                isOpen: true,
                isEdit: false,
                taskId: null,
                project: project,
                scope: scope,
              });
            }}
            setTaskStartDate={() => { }}
            handleEditTaskModal={handleEditTaskModal}
            setScopeItem={setScopeItem}
            baseLine={baseLine}
            critical={critical}
            isHideScope={isHideSideBar}
            isHideTask={isHideTask}
            count={count}
            overviewType={overviewType}
            isHeaderCollapsed={isHeaderCollapsed}
          />
        </div>
      </div>
      {showScopeModal && (
        <Modal
          title={scopeItem ? "Edit Scope" : "Create Scope"}
          handleCancel={() => handleScopeCancel()}
          handleSave={() => handleScopeSave()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={scopeLoader}
          body={scopeForm()}
          size="large"
        />
      )}
      {/* Allocation/Task Actions Conflicts Toasts */}
      {conflictsToasts.map((toast, index) => (
        <ConflictsToast
          key={index}
          data={toast}
          index={index}
          onClose={() => removeConflictsToast(index)}
        />
      ))
      }
      {taskModal.isOpen && (
        <CreateEditTask
          isOpen={taskModal.isOpen}
          isEdit={taskModal.isEdit}
          taskId={taskModal.taskId}
          projectID={taskModal.project?.id}
          projectName={taskModal.project?.name}
          scopeID={taskModal.scope?.id}
          scopeName={taskModal.scope?.name}
          onClose={closeTaskModal}
          onSave={fetchAndSetTimelineData}
        />
      )}
    </>
  );
};

const mapDispatchToProps = {
  createTaskRequest: createTask,
  updateTaskRequest: updateTask,
  resourcesShiftsRequest,
  createScopeRequest,
};

const mapStateToProps = (state) => {
  const allResourceShifts = resourceShifts(state);
  const scopeLoading = scopeStatusLoading(state);
  const taskLoader = taskLoading(state);

  return { allResourceShifts, scopeLoading, taskLoader };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
